import React from 'react';

const expireDays = 30;
const cookieName = 'pwc-cookie-accept';

class CookieBanner extends React.Component {
  state = {
    placeholderHeight: 0,
    isAgreeWithPolicy: Cookies.get(cookieName),
  };

  ref = React.createRef();

  componentDidMount() {
    if (this.ref.current?.offsetHeight)
      this.setState({ placeholderHeight: this.ref.current?.offsetHeight });
  }

  onAgreeWithPolicy = () => {
    Cookies.set(cookieName, true, { expires: expireDays });
    this.setState({ isAgreeWithPolicy: true });
  };

  render() {
    const { isAgreeWithPolicy, placeholderHeight } = this.state;

    if (!isAgreeWithPolicy)
      return (
        <React.Fragment>
          <div style={{ height: placeholderHeight }}></div>
          <div className="cookie-banner__full" ref={this.ref}>
            <div className="container cookie-banner__container">
              <div>
                <div className="cookie-banner__message">
                  Мы используем {' '}
                  <a
                    className="txt--red cookie-banner__link"
                    target="_blank"
                    href="/policy/cookie/"
                  >
                    файлы cookie
                  </a>
                  , чтобы улучшить работу сайта и
                  сделать контент более интересным для вас.
                </div>
              </div>
              <div className="cookie-banner__btn-container">
                <div className="cookie-banner__item cookie-banner__item--btn">
                  <button
                    className="btn btn--primary btn--full"
                    onClick={this.onAgreeWithPolicy}
                  >
                    Согласен
                  </button>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );

    return <div></div>;
  }
}

export default CookieBanner;
